import { render } from "./CarteBoissons.vue?vue&type=template&id=140c4a6f&scoped=true"
import script from "./CarteBoissons.vue?vue&type=script&lang=js"
export * from "./CarteBoissons.vue?vue&type=script&lang=js"

import "./CarteBoissons.vue?vue&type=style&index=0&id=140c4a6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c4a6f"]])

export default __exports__